import videoCallConstants from "../../../constants/videoCallConstants";

export const setMuteAudio = (muted) => ({
    type: videoCallConstants.MUTE_AUDIO, muted
});
export const setMuteVideo = (muted) => ({
    type: videoCallConstants.MUTE_VIDEO, muted
});